import styled from "styled-components/macro";

export const Container = styled.div`
  margin: 0px auto;
  width: 100%;
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  overflow-x: clip;

  #menu {
    display: flex;
    align-items: center;
    gap: 16px;
    margin: 8px 0 16px !important;
    min-width: 100% !important;
    top: 0;

    .left-container {
      display: flex;
      align-items: center;
      flex-shrink: 0;
      gap: 10px;

      > * {
        display: inline-flex;
        position: relative;
      }

      > * p {
        padding-right: 6px;
      }

      > * svg.import {
        path {
          fill: none;
          stroke: var(--grey-0);
        }
        margin: 0 5px 0 4px;
      }

      .new {
        font-family: Inter;
        font-weight: 500;
        border-radius: 30px;
        background: transparent;
        padding: 9px 20px 9px 15px;
        color: var(--grey-0);
        border: 2px solid var(--grey-0);
        font-size: 16px;
        line-height: 22px;
        -webkit-touch-callout: none;
        /* iOS Safari */
        -webkit-user-select: none;
        /* Safari */
        -khtml-user-select: none;
        /* Konqueror HTML */
        -moz-user-select: none;
        /* Old versions of Firefox */
        -ms-user-select: none;
        /* Internet Explorer/Edge */
        user-select: none;
        /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */

        &:hover {
          background: var(--container-color);
        }

        span {
          margin-right: 12px;
          line-height: 22px;
          position: relative;
          bottom: 1px;
          font-size: 22px;
          font-weight: bold;
        }

        &.creating {
          cursor: auto;
          color: var(--grey-0);
          opacity: 0.5;

          background: #f6f7f8;
          background-image: linear-gradient(to right, #f6f7f8 0%, #e4e4e4 20%, #f6f7f8 40%, #f6f7f8 100%);
          background-repeat: no-repeat;
          background-size: 800px 104px;

          animation-duration: 1s;
          animation-fill-mode: forwards;
          animation-iteration-count: infinite;
          animation-name: placeholderShimmer;
          animation-timing-function: linear;

          &:hover {
            background: #f6f7f8;
            background-image: linear-gradient(to right, #f6f7f8 0%, #e4e4e4 20%, #f6f7f8 40%, #f6f7f8 100%);
            background-repeat: no-repeat;
            background-size: 800px 104px;
          }
        }
      }
    }

    > a:focus-visible {
      outline: 2px solid var(--primary-cta);
      outline-offset: 4px;
      border-radius: 10px;

      .logo {
        scale: 1.03;
        filter: brightness(1.3);
      }
    }
    .logo-link {
      position: relative;
      flex-shrink: 0;
      margin-left: 54px;
    }
    .inner {
      width: auto;
      margin-bottom: 0;
      &:focus-visible {
        outline: 2px solid var(--primary-cta);
        outline-offset: 4px;
        border-radius: 10px;
        .logo {
          scale: 1.03;
          filter: brightness(1.3);
        }
      }
      &:hover {
        .logo {
          scale: 1.03;
          filter: brightness(1.3);
        }
      }

      &:active {
        .logo {
          scale: 0.95;
        }
      }
      h1 {
        display: flex;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
        .logo {
          transition:
            scale 150ms ease-in-out,
            filter 150ms ease-in-out;
          cursor: pointer;
          margin-right: 0 !important;
          opacity: 1 !important;
          top: 0 !important;
          path {
            fill: var(--grey-0) !important;
          }
        }
      }
    }

    .right-container {
      flex: 1;
      min-width: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 48px;
      gap: 4px;

      > :not(.search-input) {
        flex-shrink: 0;
      }

      .search-input {
        border-radius: 30px;
        background: var(--container-color);
        padding: 10px 30px 10px 20px;
        color: black;
        font-size: 16px;
        line-height: 22px;
        border: none;
        transition: background 150ms;
        min-width: 120px;
        width: 300px;
        color: var(--grey-0);

        ::placeholder {
          color: var(--grey-1);
        }

        &:hover {
          background: var(--container-color-2);
        }
      }
      .search {
        cursor: pointer;
        path {
          fill: var(--grey-0) !important;
          opacity: 1 !important;
        }
      }

      .changelog {
        text-align: center;
        color: var(--grey-1);
        font-size: 13px;
        font-family: Inter;
        font-weight: 500;
        text-decoration: none;
        line-height: 28px;
        margin-right: 10px;
        #fb-update-badge {
          &:empty {
            display: none;
          }
        }
        @media screen and (max-width: 1250px) {
          display: none;
        }

        span {
          display: inline-block;
          height: 10px;
          margin: 0;
          padding: 0;
        }
      }

      [data-badge-changelog]::after {
        font-size: 0;
        right: 0;
        top: 0;
        height: 6px;
        width: 6px;
        margin-right: 7px;
        // position: relative;
        // top: -1px;
        margin-left: 0;
        padding: 0;
        position: relative;
        // display: inline-block;
      }

      #help-container {
        svg {
          path {
            fill: var(--grey-0) !important;
            opacity: 1 !important;
          }
        }
      }

      #settings-container {
        svg {
          path {
            fill: var(--grey-0) !important;
            opacity: 1 !important;
          }
        }
      }
    }
  }

  .inner {
    width: 775px;
    margin-bottom: 64px;

    .header {
      &.hide {
        visibility: hidden;
        height: 0px;
        overflow: hidden;
      }

      @media screen and (max-height: 1000px) {
        margin-top: clamp(0px, calc(100vh - 700px), 128px);
      }

      margin-top: 64px;

      .breadcrumbs {
        display: flex;
        flex-direction: row;
        align-items: center;

        p {
          font-family: "GT Super Text";
          font-weight: 400;
          font-size: 21.5px;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
          color: var(--grey-0);
          cursor: pointer;
          padding: 2px 10px;
          height: 39px;
          box-sizing: border-box;
          transition:
            scale 150ms ease-in-out,
            outline 150ms ease-in-out;

          &:first-child {
            margin-left: -10px;
          }

          &.active {
            background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23ACACACFF' stroke-width='2' stroke-dasharray='6%2c 8' stroke-dashoffset='6' stroke-linecap='square'/%3e%3c/svg%3e");
            border-radius: 8px;
          }

          &.isOver {
            outline: 2px solid var(--primary-cta-background);
            outline-offset: 4px;
            scale: 1.05;
            z-index: 10;
            background-color: var(--menu-color);
          }
        }

        svg.separator {
          transform: rotate(-90deg);
          width: 12px;
          height: 12px;
          padding: 0px 6px;

          path {
            fill: var(--grey-1);
          }
        }
      }
    }

    .title-container {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 16px;

      textarea,
      .title {
        font-family: "GT Super Text";
        font-weight: 400;
        font-size: 52px;
        line-height: 58px;
        flex-grow: 1;
        padding: 1px;
        color: var(--grey-0);
      }

      .title {
        line-clamp: 2;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-pack: end;
        word-wrap: break-word;
      }

      textarea {
        background: transparent;
        border: none;
        resize: none;
      }
    }

    .buttons-container {
      margin-top: 10px;
      display: flex;
      flex-direction: row;

      .close,
      .action-menu {
        svg {
          path,
          circle {
            fill: var(--grey-1);
          }
        }
      }
    }

    .subtitle-container {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-top: 10px;

      .subtitle {
        color: var(--grey-1);
        font-size: 12px;
        font-family: "Inter";
        font-weight: 500;
        opacity: 0.7;
      }
    }
  }

  @media (max-width: 875px) {
    display: none;
  }
`;

export const FoldersContainer = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-auto-rows: 440px;
  gap: 32px;

  margin-top: 24px;
`;

export const SeriesFolderProjectsAnchor = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  pointer-events: none;
`;
